class AbstractSessionFields
{

    key;
    static BOOKING_PAYMENT_METHOD_DISAGIO_KEY = 'booking_payment_method_disagio';

    constructor(key) {
        this.key = key;
    }


    putInSession($value)
    {

    }

    removeFromSession()
    {

    }


}